// Brivio 2.0 shared design system — reuse these for every 2.0 page/screen.
import { CheckCircle2 } from "lucide-react";

const BTN_BASE = "inline-flex items-center justify-center gap-2 font-semibold transition-all duration-200 select-none disabled:opacity-50 disabled:pointer-events-none";
const BTN_SIZE = { md: "px-6 py-3 text-[15px] rounded-[14px]", lg: "px-8 py-4 text-base rounded-[16px]" };
const BTN_VARIANT = {
  primary: "bg-[var(--b2-green)] text-white hover:bg-[var(--b2-green-hover)] shadow-[var(--b2-shadow-cta)] hover:-translate-y-0.5",
  secondary: "bg-white border border-[var(--b2-border)] text-[var(--b2-navy)] hover:border-[var(--b2-green)] hover:text-[var(--b2-green)]",
  navy: "bg-[var(--b2-navy)] text-white hover:bg-[var(--b2-navy-deep)]",
  ghost: "text-[var(--b2-navy)] hover:text-[var(--b2-green)]",
};

export const B2Button = ({ variant = "primary", size = "md", className = "", children, ...props }) => (
  <button className={`${BTN_BASE} ${BTN_SIZE[size]} ${BTN_VARIANT[variant]} ${className}`} {...props}>{children}</button>
);

export const B2Card = ({ className = "", children, ...props }) => (
  <div className={`bg-white rounded-[var(--b2-radius)] border border-[var(--b2-border)] shadow-[var(--b2-shadow-card)] ${className}`} {...props}>{children}</div>
);

export const B2Input = ({ className = "", ...props }) => (
  <input className={`w-full rounded-[14px] border border-[var(--b2-border)] bg-white px-4 h-12 text-[15px] text-[var(--b2-navy)] placeholder:text-[#94A3B8] outline-none focus:border-[var(--b2-green)] focus:ring-2 focus:ring-[var(--b2-green-soft)] transition-colors ${className}`} {...props} />
);

export const B2Check = ({ children, className = "", testid }) => (
  <span data-testid={testid} className={`inline-flex items-center gap-2 text-[var(--b2-navy)] font-semibold ${className}`}>
    <CheckCircle2 className="w-5 h-5 text-[var(--b2-green)] shrink-0" /> {children}
  </span>
);

export const B2SectionTitle = ({ title, sub, center = true, className = "" }) => (
  <div className={`${center ? "text-center mx-auto max-w-2xl" : ""} ${className}`}>
    <h2 className="font-display text-3xl md:text-4xl font-extrabold tracking-tight text-[var(--b2-navy)]">{title}</h2>
    {sub && <p className="mt-3 text-base md:text-lg text-[var(--b2-ink-soft)] leading-relaxed">{sub}</p>}
  </div>
);

export const B2Badge = ({ children, className = "", testid }) => (
  <span data-testid={testid} className={`inline-flex items-center gap-1.5 rounded-full bg-[var(--b2-green-soft)] border border-[var(--b2-green-border)] text-[#166534] text-xs font-bold px-3 py-1.5 ${className}`}>{children}</span>
);
